import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useSearchParams } from "react-router-dom";
import { loadGuest } from '../../actions/auth';
import { getMyBarBooking } from '../../actions/bar';

const BarPaymentSuccess = ({loadGuest, getMyBarBooking}) => {

useEffect(()=>{
    loadGuest();
    },[loadGuest]);
  
  useEffect(()=>{
    getMyBarBooking();
  },[getMyBarBooking]);

  const searchQuery = useSearchParams()[0];
  const referenceNum = searchQuery.get("reference");
  return (
    <div className='container' style={{ "alignItems":"center", "justifyContent": "center", "textAlign": "center" }}>
    <h1 className='large' style={{ "color": "#28a745"}}> Payment Successful</h1>
    <p className='text text-primary lead'> Payment Reference Number: {referenceNum } </p>
    <button className='btn btn-light' style={{"margin": "20px"}}><Link to='/barbookings'> Go back </Link></button>
    {/* <button onClick={() => window.location.reload()}>Refresh</button> */}
    </div>
  )
}

BarPaymentSuccess.propTypes = {
  loadGuest: propTypes.func.isRequired,
  getMyBarBooking: propTypes.func.isRequired,
};

export default connect(null, {loadGuest, getMyBarBooking})(BarPaymentSuccess);